export const messages = {
  actions: {
    'en-US': {
      apply: 'Apply',
      clear: 'Clear',
      clearAll: 'Clear all',
    },
    'fr-FR': {
      apply: 'Appliquer',
      clear: 'Dégager',
      clearAll: 'Tout effacer',
    },
    'pt-BR': {
      apply: 'Aplicar',
      clear: 'Limpar',
      clearAll: 'Limpar todos',
    },
    'ja-JP': {
      apply: '申し込み',
      clear: 'クリア',
      clearAll: 'すべてクリア',
    },
    'ko-KR': {
      apply: '적용하다',
      clear: '분명한',
      clearAll: '모두 지우기',
    },
    'it-IT': {
      apply: 'Applicare',
      clear: 'Chiaro',
      clearAll: 'Cancella tutto',
    },
    'nl-NL': {
      apply: 'Van toepassing zijn',
      clear: 'Doorzichtig',
      clearAll: 'Wis alles',
    },
    'ro-RO': {
      apply: 'Aplica',
      clear: 'Clar',
      clearAll: 'Curata tot',
    },
    'bg-BG': {
      apply: 'Приложи',
      clear: 'ясно',
      clearAll: 'изчисти всичко',
    },
  },
}
